import { useEffect, useRef, useState } from "react";
import Steps from "../../../components/steps/Steps";
import TimePickerInput from "../../../components/timePickerInput/TimePickerInput";
import DatePickerInput from "../../../components/datePickerInput/DatePickerInput";
import {
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../components";
import styles from "./CreateEvent.module.css";
import RoomImage from "../../../assets/RoomImage.png";
import { Col, Row } from "antd";
import Dropdown from "../../../components/dropdowns/Dropdown";
import { useNavigate } from "react-router-dom";
import {
  CalendarIcon,
  ClockIcon,
  LocIcon,
} from "../../../components/icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
import Autocomplete from "react-google-autocomplete";
import { API_KEY } from "../../../config/Apis";
import moment from "moment";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import AutoCompleteInput from "../../../components/auntoCompleteInput/AutoCompleteInput";

const FirstStep = ({
  setCurrentStep,
  EventCategory,
  eventName,
  setEventName,
}) => {
  const [eventCategory, setEventCategory] = useState();

  return (
    <>
      <Row className={styles.row} justify={"space-between"} gutter={16}>
        <Col xs={24} md={14} lg={16}>
          <Dropdown
            label={"Event Category"}
            onChange={(e) => setEventCategory(e?.id)}
            object={EventCategory?.eventcategory}
          />
          <InputField
            label="Event Name"
            value={eventName}
            onChange={(e) => setEventName(e.target.value)}
          />
          <TextareaField label="Description" />
          <InputField label="No Of Guests" type="number" />
        </Col>
        <Col xs={24} md={10} lg={8}>
          <img className={styles.img} src={RoomImage} />
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={10} lg={8}>
          <SubmitButton
            title={"Next"}
            btnClass={styles.solidBtn}
            onClick={() => setCurrentStep((prev) => prev + 1)}
          />
        </Col>
      </Row>
    </>
  );
};

const SecondStep = ({ eventName }) => {
  console.log("eventName", eventName);
  const navigate = useNavigate();
  return (
    <>
      <Row className={styles.row} justify={"space-between"} gutter={16}>
        <Col xs={24} md={12}>
          <DatePickerInput label="Date" icon={<CalendarIcon size={25} />} />
        </Col>
        <Col xs={24} md={12}>
          <Dropdown
            label="Status"
            options={[
              { value: "Active", option: "Active" },
              { value: "Pending", option: "Pending" },
            ]}
          />
        </Col>
        <Col xs={24} md={12}>
          <TimePickerInput label="Start Time" icon={<ClockIcon size={25} />} />
        </Col>
        <Col xs={24} md={12}>
          <TimePickerInput label="End Time" icon={<ClockIcon size={25} />} />
        </Col>
        <Col xs={24} md={12}>
          <InputField label="Address" rightIcon={<LocIcon size={25} />} />
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={10} lg={8}>
          <SubmitButton
            title={"Create"}
            btnClass={styles.solidBtn}
            onClick={() => navigate(-1)}
          />
        </Col>
      </Row>
    </>
  );
};

const CreateEvent = () => {
  const EventCategory = useSelector(
    (state) => state?.GeneralReducer?.GeneralTypes
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [eventCategory, setEventCategory] = useState();
  const [currentStep, setCurrentStep] = useState([]);
  const [eventName, setEventName] = useState();
  const [currentLocation, setCurrentLocation] = useState();
  const [address, setAddress] = useState();
  const [receptionCurrLoc, setReceptionCurrLoc] = useState();
  const [receptionAddress, setReceptionAdress] = useState();
  console.log("addresssssssss", address);
  const [description, setDescription] = useState();
  const [guest, setGuest] = useState();
  const [date, setDate] = useState();
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [receptionStartTime, setReceptionStartTime] = useState();
  const [receptionEndTime, setReceptionEndTime] = useState();
  const [eventStatus, setEventStatus] = useState();
  const [profileImg, setProfileImg] = useState();
  const [brideImg, setBrideImg] = useState();
  const [brideEmail, setBrideEmail] = useState();
  const [brideContactNumber, setBrideContactNumber] = useState();
  const [brideFirstName, setBrideFirstName] = useState();
  const [brideLastName, setBrideLastName] = useState();
  const [groomImg, setGroomImg] = useState(null);
  const [groomEmail, setGroomEmail] = useState();
  const [groomContactNumber, setGroomContactNumber] = useState();
  const [groomFirstName, setGroomFirstName] = useState();
  const [groomLastName, setGroomLastName] = useState();

  const hiddenFileInputProfile = useRef();
  const handleClickProfile = (event) => {
    hiddenFileInputProfile.current.click();
  };

  const hiddenFileInputBride = useRef();
  const handleClickBride = (event) => {
    hiddenFileInputBride.current.click();
  };

  const hiddenFileInputGroom = useRef();
  const handleClickGroom = (event) => {
    hiddenFileInputGroom.current.click();
  };

  useEffect(() => {
    dispatch(AuthMiddleware.GeneralType());
    setCurrentStep(stepLinks[0].id);
  }, []);

  const stepLinks = [
    {
      id: 1,
    },
    {
      id: 2,
    },
    {
      id: 3,
    },
  ];

  const onPressCreate = () => {
    let userData = {
      eventImage: profileImg,
      EventName: eventName,
      SelectedEventCategoryID: eventCategory?.id,
      Description: description,
      date: moment(date?.$d).format("YYYY-MM-DD"),
      startTime: moment(startTime?.$d).format("HH:mm"),
      endTime: moment(endTime?.$d).format("HH:mm"),
      address,
      lat: currentLocation?.lat,
      lng: currentLocation?.lng,
      receptionAddress,
      receptionLat: receptionCurrLoc?.lat,
      receptionLng: receptionCurrLoc?.lng,
      receptionStartTime: moment(receptionStartTime?.$d).format("HH:mm"),
      receptionEndTime: moment(receptionEndTime?.$d).format("HH:mm"),
      guest,
      SelectedStatus: eventStatus,
      brideImage: brideImg,
      brideFName: brideFirstName,
      brideLName: brideLastName,
      brideEmail: brideEmail,
      brideContactNumber: brideContactNumber,
      groomImage: groomImg,
      groomFName: groomFirstName,
      groomLName: groomLastName,
      groomEmail: groomEmail,
      groomContactNumber: groomContactNumber,
    };
    if (!brideImg) {
      dispatch(
        showAlert({
          title: "Create Event",
          message: "Add bride image.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      !brideFirstName ||
      !brideLastName ||
      !brideEmail ||
      !brideContactNumber
    ) {
      dispatch(
        showAlert({
          title: "Create Event",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(brideEmail) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Email!",
          message:
            "Please enter a valid email address of bride (e.g., example@example.com)",
        })
      );
      return;
    } else if (!groomImg) {
      dispatch(
        showAlert({
          title: "Create Event",
          message: "Add groom image.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      !groomFirstName ||
      !groomLastName ||
      !groomEmail ||
      !groomContactNumber
    ) {
      dispatch(
        showAlert({
          title: "Create Event",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(groomEmail) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Email!",
          message:
            "Please enter a valid email address of groom (e.g., example@example.com)",
        })
      );
      return;
    } else {
      dispatch(EventMiddleware.createEvent(userData))
        .then(() => {
          navigate("/events");
        })
        .catch((err) => console.log(err));
    }
  };
  //   if (!profileImg) {
  //     dispatch(
  //       showAlert({
  //         title: "Create Event",
  //         message: "Add event image.",
  //         type: "Error",
  //         status: 400,
  //       })
  //     );
  //     return;
  //   } else if (
  //     !eventName ||
  //     !eventCategory ||
  //     !description ||
  //     !date ||
  //     !startTime ||
  //     !endTime ||
  //     !address ||
  //     !guest ||
  //     !eventStatus
  //   ) {
  //     dispatch(
  //       showAlert({
  //         title: "Create Event",
  //         message: "All fields are mandatory.",
  //         type: "Error",
  //         status: 400,
  //       })
  //     );
  //     return;
  //   } else {
  //     let EventData = {
  //       eventImage: profileImg,
  //       EventName: eventName,
  //       SelectedEventCategoryID: eventCategory,
  //       Description: description,
  //       date: moment(date).format("YYYY-MM-DD"),
  //       startTime: moment(startTime).format("HH:mm"),
  //       endTime: moment(endTime).format("HH:mm"),
  //       address,
  //       lat: "40.80023",
  //       lng: "-73.96251",
  //       guest,
  //       SelectedStatus: eventStatus,
  //     };
  //     // navigation.navigate('CreateBrideGroom',{routeType: routeType, routeData: EventData})
  //     console.log(EventData);
  //   }
  // };

  function handleNextProfile() {
    if (profileImg && eventCategory && eventName && description && guest) {
      setCurrentStep((prev) => prev + 1);
    } else {
      dispatch(
        showAlert({ type: "Error", message: "All fields are mandatory!" })
      );
    }
  }

  function handleNextDetails() {
    if (
      moment(startTime?.$d).format("HH:mm") >
      moment(endTime?.$d).format("HH:mm")
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Start time should be less than End time",
        })
      );
    } else if (
      moment(receptionStartTime?.$d).format("HH:mm") >
      moment(receptionEndTime?.$d).format("HH:mm")
    ) {
      dispatch(
        showAlert({
          type: "Error",
          message:
            "Reception Start time should be less than Reception End time",
        })
      );
    } else if (
      date &&
      eventStatus &&
      endTime &&
      startTime &&
      address &&
      receptionEndTime &&
      receptionStartTime &&
      receptionAddress
    ) {
      setCurrentStep((prev) => prev + 1);
    } else {
      dispatch(
        showAlert({ type: "Error", message: "All fields are mandatory!" })
      );
    }
  }

  return (
    <div>
      <Steps
        stepLinks={stepLinks}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />

      {currentStep == 1 ? (
        <>
          <Row className={styles.row} justify={"space-between"} gutter={16}>
            <Col xs={24} md={14} lg={16}>
              <Dropdown
                label={"Event Category"}
                onChange={(e) => setEventCategory(e)}
                object={EventCategory?.eventcategory}
                // selectedValue={eventCategory?.val}
                placeholder={"Select Event Category"}
              />
              <InputField
                label="Event Name"
                placeholder={"Wedding"}
                value={eventName}
                onChange={(e) => setEventName(e.target.value)}
              />
              <TextareaField
                label="Description"
                placeholder={
                  "Experience the ultimate wedding planning companion app. Manage guests, RSVPs, vendors, and make your dream wedding a reality"
                }
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <InputField
                label="No Of Guests"
                placeholder={"20"}
                type="number"
                value={guest}
                onChange={(e) => setGuest(e.target.value)}
              />
            </Col>
            <Col xs={24} md={10} lg={8}>
              <div onClick={handleClickProfile}>
                <img
                  className={styles.img}
                  src={profileImg ? URL.createObjectURL(profileImg) : RoomImage}
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files[0] && setProfileImg(e.target.files[0])
                  }
                  ref={hiddenFileInputProfile}
                  style={{ display: "none" }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={10} lg={8}>
              <SubmitButton
                title={"Next"}
                btnClass={styles.solidBtn}
                onClick={handleNextProfile}
              />
            </Col>
          </Row>
        </>
      ) : currentStep == 2 ? (
        <>
          <Row className={styles.row} justify={"space-between"} gutter={16}>
            <Col xs={24} md={12}>
              <DatePickerInput
                label="Event Date"
                icon={<CalendarIcon size={25} />}
                value={date}
                onChange={(e) => setDate(e)}
              />
            </Col>
            <Col xs={24} md={12}>
              <Dropdown
                label="Status"
                options={[
                  { value: "Active", option: "Active" },
                  { value: "Pending", option: "Pending" },
                ]}
                onChange={(e) => setEventStatus(e)}
                selectedValue={eventStatus}
              />
            </Col>
            <Col xs={24} md={12}>
              <TimePickerInput
                label="Ceremony Start Time"
                icon={<ClockIcon size={25} />}
                value={startTime}
                onChange={(e) => setStartTime(e)}
              />
            </Col>
            <Col xs={24} md={12}>
              <TimePickerInput
                label="Ceremony End Time"
                icon={<ClockIcon size={25} />}
                value={endTime}
                onChange={(e) => setEndTime(e)}
              />
            </Col>
            <Col xs={24} md={12}>
              <AutoCompleteInput
                label={"Ceremony Location"}
                placeholder={address}
                address={currentLocation?.adress}
                onSelectPlace={(place) => {
                  let currentLocation = {
                    lat: place?.geometry?.location?.lat(),
                    lng: place?.geometry?.location?.lng(),
                    address: place?.formatted_address,
                  };
                  setAddress(currentLocation?.address);
                  setCurrentLocation(currentLocation);
                }}
              />
              {/* <Autocomplete
                apiKey={API_KEY}
                style={{ width: "100%" }}
                placeholder={address}
                onPlaceSelected={(place) => {
                  let currentLocation = {
                    lat: place?.geometry?.location?.lat(),
                    lng: place?.geometry?.location?.lng(),
                    address: place?.formatted_address,
                  };
                  setCurrentLocation(currentLocation);
                }}
                options={{
                  types: ["geocode", "establishment"],
                }}
                language={"en"}
              /> */}
            </Col>
            <Col xs={24} md={12}>
              <AutoCompleteInput
                label={"Reception Location"}
                placeholder={receptionAddress}
                address={receptionCurrLoc?.adress}
                onSelectPlace={(place) => {
                  let receptionCurrLoc = {
                    lat: place?.geometry?.location?.lat(),
                    lng: place?.geometry?.location?.lng(),
                    address: place?.formatted_address,
                  };
                  setReceptionAdress(receptionCurrLoc?.address);
                  setReceptionCurrLoc(receptionCurrLoc);
                }}
              />
            </Col>

            <Col xs={24} md={12}>
              <TimePickerInput
                label="Reception Start Time"
                icon={<ClockIcon size={25} />}
                value={receptionStartTime}
                onChange={(e) => setReceptionStartTime(e)}
              />
            </Col>
            <Col xs={24} md={12}>
              <TimePickerInput
                label="Reception End Time"
                icon={<ClockIcon size={25} />}
                value={receptionEndTime}
                onChange={(e) => setReceptionEndTime(e)}
              />
            </Col>
          </Row>
          <Row gutter={[8, 12]}>
            <Col xs={24} sm={12} md={10} lg={8}>
              <SubmitButton
                title={"Back"}
                btnClass={styles.solidBtn}
                onClick={() => setCurrentStep((prev) => prev - 1)}
              />
            </Col>
            <Col xs={24} sm={12} md={10} lg={8}>
              <SubmitButton
                title={"Next"}
                btnClass={styles.solidBtn}
                onClick={handleNextDetails}
              />
            </Col>
          </Row>
        </>
      ) : currentStep === 3 ? (
        <>
          <TextComponent textClass={styles.heading}>
            Bride Details
          </TextComponent>
          <Row className={styles.row} justify={"space-between"} gutter={16}>
            <Col xs={24} md={14} lg={16}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>
                  <InputField
                    label="First Name"
                    placeholder="Enter First Name"
                    value={brideFirstName}
                    onChange={(e) => setBrideFirstName(e.target.value)}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <InputField
                    label="Last Name"
                    placeholder="Enter Last Name"
                    value={brideLastName}
                    onChange={(e) => setBrideLastName(e.target.value)}
                  />
                </Col>
              </Row>
              <InputField
                label="Email"
                placeholder="Enter Email"
                value={brideEmail}
                type="email"
                onChange={(e) => setBrideEmail(e.target.value)}
              />
              <PhoneInput
                className={styles.phoneInput}
                value={brideContactNumber}
                onChange={setBrideContactNumber}
                label={"Contact Number"}
              />
            </Col>
            <Col xs={24} md={10} lg={8}>
              <div onClick={handleClickBride}>
                <img
                  className={styles.img}
                  src={brideImg ? URL.createObjectURL(brideImg) : RoomImage}
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files[0] && setBrideImg(e.target.files[0])
                  }
                  ref={hiddenFileInputBride}
                  style={{ display: "none" }}
                />
              </div>
            </Col>
          </Row>
          {/* <Row>
            <Col xs={24} md={10} lg={8}>
              <SubmitButton
                title={"Create"}
                btnClass={styles.solidBtn}
                // onClick={() => setCurrentStep((prev) => prev + 1)}
              />
            </Col>
          </Row> */}
          <TextComponent textClass={styles.heading}>
            Groom Details
          </TextComponent>
          <Row className={styles.row} justify={"space-between"} gutter={16}>
            <Col xs={24} md={14} lg={16}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12}>
                  <InputField
                    label="First Name"
                    placeholder="Enter First Name"
                    value={groomFirstName}
                    onChange={(e) => setGroomFirstName(e.target.value)}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <InputField
                    label="Last Name"
                    placeholder="Enter Last Name"
                    value={groomLastName}
                    onChange={(e) => setGroomLastName(e.target.value)}
                  />
                </Col>
              </Row>
              <InputField
                label="Email"
                placeholder="Enter Email"
                value={groomEmail}
                type="email"
                onChange={(e) => setGroomEmail(e.target.value)}
              />
              <PhoneInput
                className={styles.phoneInput}
                value={groomContactNumber}
                onChange={setGroomContactNumber}
                label={"Contact Number"}
              />
            </Col>
            <Col xs={24} md={10} lg={8}>
              <div onClick={handleClickGroom}>
                <img
                  className={styles.img}
                  src={groomImg ? URL.createObjectURL(groomImg) : RoomImage}
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files[0] && setGroomImg(e.target.files[0])
                  }
                  ref={hiddenFileInputGroom}
                  style={{ display: "none" }}
                />
              </div>
            </Col>
          </Row>
          <Row gutter={[8, 12]}>
            <Col xs={24} sm={12} md={10} lg={8}>
              <SubmitButton
                title={"Back"}
                btnClass={styles.solidBtn}
                onClick={() => setCurrentStep((prev) => prev - 1)}
              />
            </Col>
            <Col xs={24} sm={12} md={10} lg={8}>
              <SubmitButton
                title={"Create"}
                btnClass={styles.solidBtn}
                onClick={onPressCreate}
              />
            </Col>
          </Row>
        </>
      ) : null}
    </div>
  );
};

export default CreateEvent;
